/* eslint-disable */
import { Component } from 'react';
import { Trans } from 'Helpers';
import { Modal, ModalBody, Button, ModalHeader, ModalFooter } from 'reactstrap'
import {Images} from 'Helpers';

class JoinedConfirmationModal extends Component {
  render() {
    const {isOpen, createTeam, joinMore} = this.props
    
    
    return (
      <Modal  isOpen={isOpen} size='sm' centered className='confirmation-modal'>
        <div className='circle-check'>
          <i className='icon-check'></i>
        </div>
        <h4 className='confrim-head'>GAME ON!</h4>
        <ModalBody className='joined-confimation-body'>
          <div className="confirm-body-wrap">
              <h4>The competition has been joined successfully</h4>
          </div>
        </ModalBody>
        <ModalFooter className='joined-confimation-footer'>
          <button onClick={joinMore} className='btn btn-primary'>Join more <br />competitions</button>
          <button onClick={createTeam} className='btn btn-primary'>Create Team<br /> Now</button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default JoinedConfirmationModal;
